/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Model_Unavailable_QuotaInputs */

const en_model_unavailable_quota = /** @type {(inputs: Model_Unavailable_QuotaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Busy right now — back ${i?.when}`)
};

const id_model_unavailable_quota = /** @type {(inputs: Model_Unavailable_QuotaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sedang penuh — tersedia lagi ${i?.when}`)
};

/**
* | output |
* | --- |
* | "Busy right now — back {when}" |
*
* @param {Model_Unavailable_QuotaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_unavailable_quota = /** @type {((inputs: Model_Unavailable_QuotaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Unavailable_QuotaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_unavailable_quota(inputs)
	return en_model_unavailable_quota(inputs)
});